import request from "@/utils/request";

export async function getQuoteRuleResults(pricingEngineResultId) {
  const params = {
    pricingEngineResultId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quote-rule-results`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function getPricingEngineResultByQuoteIds(quoteIds) {
  const params = {
    quoteIds,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/engine-result/by-quote-ids`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function runPricingEngine(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/engine`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}
